export default "__VITE_ASSET__BIgkLuJH__"